import AxiosInstance from './Http'

export const DEFAULT_PAGE_SIZE = 20
export const BATCH_PAGE_SIZE = DEFAULT_PAGE_SIZE

type PageResponse<T> = {
  data?: T[] | { content?: T[] }
}

const getPageItems = <T>(response: PageResponse<T>): T[] => {
  if (Array.isArray(response.data)) {
    return response.data
  }

  return response.data?.content ?? []
}

export const fetchAllPages = async <T>(
  url: string,
  params: Record<string, any> = {},
  pageSize: number = BATCH_PAGE_SIZE
) => {
  const items: T[] = []
  let page = 0
  let lastResponse: PageResponse<T> | undefined

  while (true) {
    const response = await AxiosInstance.get(url, {
      params: {
        ...params,
        page,
        size: pageSize,
      },
    })

    lastResponse = response
    const pageItems = getPageItems<T>(response)
    items.push(...pageItems)

    if (pageItems.length < pageSize) {
      return {
        ...response,
        data: items,
      }
    }

    page += 1
  }

  return {
    ...lastResponse,
    data: items,
  }
}
